import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueHead from 'vue-head'
import VueMeta from 'vue-meta'

Vue.config.productionTip = false

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

import './assets/overrides.scss'

import VueAnalytics from 'vue-analytics'
import VueSocialSharing from 'vue-social-sharing'

Vue.use(VueSocialSharing)
Vue.use(VueHead)
Vue.use(VueMeta)
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(VueAnalytics, {
  id: 'UA-169353883-1',
  router
})

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faFacebookF } from '@fortawesome/free-brands-svg-icons'
import { faTwitter } from '@fortawesome/free-brands-svg-icons'
import { faFacebookMessenger } from '@fortawesome/free-brands-svg-icons'
import { faRedditAlien } from '@fortawesome/free-brands-svg-icons'
import { faTelegramPlane } from '@fortawesome/free-brands-svg-icons'
import { faWhatsapp} from '@fortawesome/free-brands-svg-icons'

library.add(faFacebookF)
library.add(faTwitter)
library.add(faFacebookMessenger)
library.add(faRedditAlien)
library.add(faTelegramPlane)
library.add(faWhatsapp)

Vue.component('font-awesome-icon', FontAwesomeIcon)

new Vue({
  router,
  metaInfo: {
    titleTemplate: 'Scientific Edibles - %s'
  },
  render: h => h(App)
}).$mount('#app')
